import { Trans } from "react-i18next";

import util from "utils/utils";

import type { NotificationContentProps } from "../../types";

export default function DiscussionPollVotedContent({
  events = [],
  ownerIdea,
  ownerChallenge,
  ownerGroup,
  context,
  status,
}: NotificationContentProps) {
  const event = events?.[0];
  const resolvedOwnerGroup = ownerGroup || event?.ownerGroup;

  return (
    <Trans
      i18nKey="notifications.groupDiscussionPollVoted"
      values={{
        name: util.getEventNames(events ?? []),
        group: resolvedOwnerGroup?.name || "Deleted",
        discussionTitle: event?.discussionTitle || "Discussion",
      }}
    />
  );
}
